<template>
    <div>
        <!--  Logged in User  -->
        <div v-if="current_user">
            <!-- Anti-Sausage Measures -->
            <div v-if="!canUseSearch" class="container mt-5 text-center">
                <!--  Force them to pick a vehicle make  -->
                <div class="bsrow mb-3">
                    <div class="col-md-9">
                        <div class="form-field dsd-input">
                            <label class="form-control form-label form-label--alternate form-label--inlineSmall">
                                Select Your Vehicle Make
                                <select v-model="current_vehicle.make"
                                    class="select select-bordered w-full max-w-xs p-1">
                                    <option disabled selected>Select your Vehicle Make...</option>
                                    <option v-for="make of veh_make_options" :key="make" :value="make">{{
                                        make
                                    }}
                                    </option>
                                    <option :key="'Other'" :value="'Other'">Other...</option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Search Inputs -->
            <div class="container mt-5" v-else>
                <div class="bsrow mb-3">
                    <!-- Reg Search. -->
                    <div class="col-md-6">
                        <div class="form-field">
                            <dsd-input label="Reg (UK Only)" placeholder="Enter Reg" v-model="current_vehicle.reg"
                                       uppercase :maxlength="8" :minlength="1" ref="reg_ecu_input" button="Search"
                                       @btnclick="GetServicesByReg" @keydown.enter="GetServicesByReg"
                                       :disabled="IsLoading"></dsd-input>
                        </div>
                    </div>
                    <!-- VIN SEARCH  -->
                    <div class="col-md-6">
                        <div class="form-field">
                            <label class="form-label form-label--alternate form-label--inlineSmall">VIN</label>
                            <p>Please <a href="/contact-us">contact us</a> for a quote</p>
<!--                            <dsd-input label="VIN" placeholder="Enter VIN" v-model="current_vehicle.vin" uppercase-->
<!--                                :maxlength="17" :minlength="17" required ref="vin_ecu_input" button="Search"-->
<!--                                @btnclick="GetServicesByVin" @keydown.enter="GetServicesByVin"-->
<!--                                :disabled="IsLoading"></dsd-input>-->
                        </div>
                    </div>
                </div>
                <!--  Current Vehicle Output  -->
                <div class="bsrow mb-1" v-if="current_vehicle.model !== ''">
                    <div class="col-md-12">
                        <table class="table mt-1">
                            <tr style="border-bottom: 1px solid #dcdcdc;" v-if="current_vehicle.make !== ''">
                                <td>Vehicle Make</td>
                                <td>{{ current_vehicle.make }}</td>
                            </tr>
                            <tr style="border-bottom: 1px solid #dcdcdc;" v-if="current_vehicle.model !== ''">
                                <td>Vehicle Model</td>
                                <td>{{ current_vehicle.model }}</td>
                            </tr>
                            <tr style="border-bottom: 1px solid #dcdcdc;" v-if="current_vehicle.year !== ''">
                                <td>Year</td>
                                <td>{{ current_vehicle.year }}</td>
                            </tr>
                            <tr style="border-bottom: 1px solid #dcdcdc;" v-if="current_vehicle.engine_code !== ''">
                                <td>Engine Code</td>
                                <td>{{ current_vehicle.engine_code }}</td>
                            </tr>
                            <tr style="border-bottom: 1px solid #dcdcdc;" v-if="current_vehicle.bhp !== ''">
                                <td>BHP</td>
                                <td>{{ current_vehicle.bhp }}</td>
                            </tr>
                            <tr style="border-bottom: 1px solid #dcdcdc;"
                                v-if="current_vehicle.transmission_type !== ''">
                                <td>Transmission Type</td>
                                <td>{{ current_vehicle.transmission_type }}</td>
                            </tr>
                            <!--              comment out for PWG3-->
                            <tr style="border-bottom: 1px solid #dcdcdc;"
                                v-if="current_vehicle.powergate_compatible !== ''">
                                <td>Is Powergate Compatible?</td>
                                <td>{{ current_vehicle.powergate_compatible }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <!-- OLD ECU Notice for EDC15V  -->
                <div class="bsrow mb-3" v-if="current_vehicle.ecu === 'EDC15V'">
                    <div class="col-md-12">
                        <div class="form-field d-block">
                            <label class="form-label form-label--alternate form-label--inlineSmall"
                                style="margin-bottom: 0">
                                PLEASE NOTE - Models with a 2 Pin connection will require a 2 Pin to OBD adapter cable
                            </label>
                        </div>
                    </div>
                </div>
                <!--  Main Remap options  -->
                <div v-if="remapOptions.length > 0">
                    <div v-if="ShowOnsite">
                        <div class="content dsd-box">
                            <label class="form-label form-label--alternate form-label--inlineSmall mb-sm">Select your
                                tune</label>
                            <ul class="options remap no-margin no-padding">
                                <li @click="SelectRemapOption('No Remap', 0)" :class="{ 'selected': !selectedRemap }">
                                    <div>No Remap</div>
                                    <small>ECU software changes without Performance Tuning. Please choose from the
                                        ADDITIONAL OPTIONS
                                        below.</small>
                                </li>
                                <li v-for="(opt, index) in remapOptions" :key="opt.service" v-show="!opt.hidden"
                                    :class="{ 'selected': opt.checked }" @click="SelectRemapOption(opt, index)">
                                    <div class="d-flex">
                                        <div>
                                            {{ opt.service }}
                                            <small v-if="opt.service.toLowerCase().includes('standard car')">ECU Tuning
                                                for vehicles with
                                                STOCK HARDWARE or MINOR MODIFICATIONS including
                                                Exhausts, Intercoolers, Air Filters etc.</small>

                                            <small v-if="opt.service.toLowerCase() === 'remap standard turbo'">ECU
                                                Tuning for vehicles
                                                installed with a BOLT ON TURBO UPGRADE. These are OEM
                                                Turbochargers that fits with the stock downpipe generally found on
                                                higher bhp models.</small>

                                            <small v-if="opt.service.toLowerCase() === 'remap big turbo kit'">ECU Tuning
                                                for vehicles
                                                installed with a DARKSIDE TURBO/KIT (GTB
                                                / GTD Turbocharger or Similar)</small>

                                            <small v-if="opt.service.toLowerCase() === 'nozzles and injectors'">ECU
                                                Tuning for vehicles
                                                installed with Race Injectors / Nozzles.</small>

                                            <small v-if="opt.service.toLowerCase().includes('bespoke tuning')">Bespoke
                                                ECU Tuning for vehicles
                                                that do not fall into the above categories.
                                                Please add the full vehicle specs into the notes above.</small>
                                        </div>
                                        <span class="powergate-price">{{ GetPrice(opt.price) }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!-- Options Lists -->
                        <div class="content dsd-box mt-md">
                            <label class="form-label form-label--alternate form-label--inlineSmall mb-sm">Select any
                                additional
                                options</label>
                            <ul v-if="selectedRemap" class="options remap no-margin no-padding">
                                <li v-for="opt in withRemap" :key="opt.service" @click="SelectOption(opt)"
                                    :class="{ 'selected': opt.checked }">
                                    <div class="d-flex">
                                        <div>
                                            {{ opt.service }}
                                            <small v-if="opt.service.toLowerCase().includes('egr software')">
                                                Removes EGR Software from ECU
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('dpf and egr software')">
                                                Removes EGR &amp; DPF Software from ECU
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('hardcut limiter')">
                                                A fuel cut limiter at a set RPM (usually ~4800RPM) making the revs
                                                bounce. (Popcorn)
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('left foot brake')">
                                                Disables the OEM power cut when braking and accelerating at the same
                                                time. Ideal for track use
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('vmax removal')">
                                                Removes factory speed limitations
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('hotstart fix')">
                                                Fixes starting issue on cars when warm
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('map switching')">
                                                Switch between multiple maps (i.e. Road, Fast Road, Track) Each tune
                                                purchase separately
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('swirl flap')">
                                                Removes Swirl Flap software from ECU
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('cp3')">
                                                Calibration for vehicles running a CP3 HPFP (No Tuning)
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('stage 1')">
                                                Low Speed 1st / 2nd Gear Lag Fix, Increase torque limit & Disable Auto
                                                Up-Shift In Manual Mode
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('stage 2')">
                                                [ Gearbox Stage 1 ] + Optimised Launch Control
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('stage 3')">
                                                [ Gearbox Stage 1 & 2 ] + Further Torque Limit Increases, Increase
                                                Clutch Pressure, Quicker Shifting Times, Shift Lever Delay Removed,
                                                Optimised Shift Points in D & S
                                            </small>
                                            <small v-if="opt.service.toLowerCase().includes('stage 4')">
                                                Please contact us for Pricing for this option! [ Gearbox Stage 1, 2 & 3
                                                ] + Further Torque Limit Increases,
                                                Increase Clutch Pressure,
                                                Quicker Shifting Times,
                                                Shift Lever Delay Removed,
                                                Optimised Shift Points in D & S
                                            </small>
                                        </div>
                                        <span class="powergate-price">{{ GetPrice(opt.price) }}</span>
                                    </div>
                                </li>
                            </ul>
                            <!--  options services W/O Remap-->
                            <ul class="options remap no-margin no-padding" v-else>
                                <li v-for="opt in options" :key="opt.service" v-show="!opt.hidden"
                                    @click="SelectOption(opt)" :class="{ 'selected': opt.checked }">
                                    <div class="d-flex">
                                        <div>
                                            {{ opt.service }}
                                            <small v-if="opt.service.toLowerCase().includes('egr software')">Removes EGR
                                                Software from
                                                ECU</small>
                                            <small
                                                v-if="opt.service.toLowerCase().includes('dpf and egr software')">Removes
                                                EGR &amp; DPF
                                                Software from ECU</small>
                                            <small v-if="opt.service.toLowerCase().includes('hardcut limiter')">A fuel
                                                cut limiter at a set
                                                RPM (usually ~4800RPM) making the revs bounce.
                                                (Popcorn)</small>
                                            <!--                  <small v-if="opt.service.toLowerCase().includes('launch control')">A lower RPM limit when stationary or at low speeds (usually &#x3c; 5mph)</small>-->
                                            <small v-if="opt.service.toLowerCase().includes('left foot brake')">Disables
                                                the OEM power cut
                                                when braking and accelerating at the same time. Ideal for track
                                                use</small>
                                            <small v-if="opt.service.toLowerCase().includes('vmax removal')">Removes
                                                factory speed
                                                limitations</small>
                                            <small v-if="opt.service.toLowerCase().includes('hotstart fix')">Fixes
                                                starting issue on cars when
                                                warm</small>
                                            <small v-if="opt.service.toLowerCase().includes('map switching')">Switch
                                                between multiple maps
                                                (i.e. Road, Fast Road, Track) Each tune purchase
                                                separately</small>
                                            <small v-if="opt.service.toLowerCase().includes('swirl flap')">Removes Swirl
                                                Flap software from
                                                ECU</small>
                                            <small v-if="opt.service.toLowerCase().includes('cp3')">Calibration for
                                                vehicles running a CP3
                                                HPFP (No Tuning)</small>
                                            <small v-if="opt.service.toLowerCase().includes('stage 1')">Low Speed 1st /
                                                2nd Gear Lag Fix,
                                                Increase torque limit & Disable Auto Up-Shift In Manual Mode</small>
                                            <small v-if="opt.service.toLowerCase().includes('stage 2')">[ Gearbox Stage
                                                1 ] + Optimised Launch
                                                Control</small>
                                            <small v-if="opt.service.toLowerCase().includes('stage 3')">[ Gearbox Stage
                                                1 & 2 ] + Further Torque
                                                Limit Increases, Increase Clutch Pressure, Quicker Shifting Times, Shift
                                                Lever Delay Removed,
                                                Optimised Shift Points in D & S</small>
                                            <small v-if="opt.service.toLowerCase().includes('stage 4')">Please contact
                                                us for Pricing for this option! [ Gearbox Stage 1, 2 & 3 ] + Further
                                                Torque
                                                Limit Increases, Increase Clutch Pressure, Quicker Shifting Times, Shift
                                                Lever Delay Removed,
                                                Optimised Shift Points in D & S</small>
                                        </div>
                                        <span class="powergate-price">{{ GetPrice(opt.price) }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <!-- TOTALS -->
                        <div class="content dsd-box mt-md" v-if="SelServices.length > 0">
                            <div class="d-flex p-1">
                                <span><b>Total Price</b></span>
                                <span class="ml-auto"><span v-if="bespokeSelected">From </span>£{{
                                    optionsTotal
                                }}</span>
                            </div>
                            <hr style="margin: 10px 0" />
                            <div class="p-1">
                                <ul class="list-style-none">
                                    <li v-for="serv in SelServices" :key="serv.service">
                                        <div class="d-flex">
                                            <span>{{ serv.service }}</span>
                                            <span class="ml-auto">{{ GetPrice(serv.price) }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <hr style="margin: 10px 0" />
                            <div class="d-flex p-1">
                                <span><b>Total Price inc VAT</b></span>
                                <span class="ml-auto"><span v-if="bespokeSelected">From </span><b>£{{
                                    (optionsTotal * 1.2).toFixed(2)
                                        }}</b></span>
                            </div>
                        </div>
                        <!--  Current Vehicle Mods  -->
                        <div class="content dsd-box mt-md">
                            <div class="mb-sm">
                                <label class="form-label form-label--alternate form-label--inlineSmall">List all current
                                    vehicle
                                    modifications:</label>
                                <textarea class="form-input" v-model="current_vehicle.current_mods"
                                    isp_ignore></textarea>
                            </div>
                        </div>
                        <!-- Customer Notes -->
                        <div class="content dsd-box mt-md" style="margin-bottom: 50px">
                            <div class="mb-sm">
                                <label class="form-label form-label--alternate form-label--inlineSmall">Notes:</label>
                                <textarea class="form-input" v-model="notes" isp_ignore></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="productView-options productView-options--3col" style="margin: 0"
                    v-if="SelServices.length > 0">
                    <!-- Terms and Conds -->
                    <div class="emthemesModez-productView-optionsGrid" style="margin: 0">
                        <div data-product-option-change style v-if="canPurchaseTune">
                            <div class="form-field" data-product-attribute="input-checkbox" style="margin:0;width:100%">
                                <label class="form-label form-label--alternate form-label--inlineSmall">
                                    Terms:
                                    <small>Required</small>
                                </label>
                                <div>
                                    <input type="hidden" name="attribute[2559]" value="2064" />
                                    <input class="form-checkbox" type="checkbox" name="attribute[2559]"
                                        id="attribute-2559_" value="2063" required v-model="terms" />
                                    <label class="form-label" for="attribute-2559_">I have read the terms below.</label>
                                </div>
                                <div style="margin-top:20px">
                                    <input type="hidden" name="attribute[9999]" value="9999" />
                                    <input class="form-checkbox" type="checkbox" name="attribute[9999]"
                                        id="attribute-9999_" value="2063" required v-model="terms2" />
                                    <label class="form-label" for="attribute-9999_">I accept that Darkside Developments
                                        will NOT tune
                                        vehicles
                                        fitted with hybrid turbos, imitated / copied Darkside Developments products.
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Login and Add to Cart inputs -->
                    <div class="form-action" style="width: 100%;">
                        <input :disabled="!terms || !terms2" id="form-action-addToCart" class="button button--primary"
                            type="submit" value="Add To Cart" style="color:#fff; width: 100%;"
                            @click="CreateOrder($event)" v-if="current_user" />
                        <input id="form-action-addToCart" class="button button--primary" type="submit"
                            value="Login to order" style="color:#fff; width: 100%;" @click="GoToSignin($event)"
                            v-else />
                    </div>
                </div>

                <div id="modal_overlay" v-if="showCheckout" @click="showCheckout = false"></div>

                <dsd-dialog ref="dsddialog"></dsd-dialog>
                <issue-dialog ref="issuedialog"></issue-dialog>
            </div>
        </div>
        <!--  Not Logged in yet  -->
        <div class="modal-login" v-else>
            <div class="contain d-flex" style="margin-top:40px;">
                <div>
                    <div class="productView-options productView-options--1col" style="text-align: center">
                        <h4>You need to login or create an account before pricing / purchasing a remote tune.</h4>
                        <button class="button button--primary" style="color: #fff" id="trigger-login-modal"
                            @click="showModal = !showModal">SIGN IN
                        </button>

                        <a class="button button--primary" style="color: #fff" id="trigger-login-modal"
                            :href="`${this.baseURL}/login.php?action=create_account`"
                            target="_blank">CREATE ACCOUNT</a>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div id="modal-login-overlay" v-if="showModal" @click="showModal = false"></div>
            </transition>
            <transition name="fade">
                <div id="modal-login-modal" v-if="showModal">
                    <div class="login-screen">
                        <div class="login-modal-title">
                            <h1>Sign In</h1>
                        </div>

                        <div class="login-modal-form">
                            <div v-if="login.error_msg !== ''">
                                <p v-if="login.error_msg.password">Password Incorrect</p>
                                <p v-if="login.error_msg.email">Email Incorrect</p>
                            </div>
                            <div class="modal-control-group">
                                <input type="email" class="login-modal-field" v-model="login.email" placeholder="Email"
                                    id="login-name">
                                <label class="login-field-icon fui-user" for="login-name"></label>
                            </div>

                            <div class="modal-control-group">
                                <input type="password" class="login-modal-field" v-model="login.password"
                                    placeholder="Password" id="login-pass">
                                <label class="login-field-icon fui-lock" for="login-pass"></label>
                            </div>

                            <button class="btn btn-primary btn-large btn-block login-modal-btn"
                                @click="LoginCustomer($event)">Sign in
                            </button>
                            <a class="login-modal-link"
                                :href="`${this.baseURL}/login.php?action=reset_password`"
                                target="_blank">Forgot your password?</a>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-irregular-whitespace */
import jwt_decode from "jwt-decode";
import axios from "axios";

let api_url = "https://api.darkside-developments.com";
if (location.hostname === "localhost") {
    api_url = "http://127.0.0.1:8000"
}

export default {
    name: "PriceList",
    data: () => ({
        baseURL: `https://${window.location.hostname}`,

        showModal: false,
        IsLoading: false,
        showSignupModal: false,
        remapOptions: [],
        withRemap: [],
        options: [],
        selectedRemap: false,
        showDialog: false,
        services: [],
        tuningRate: 0,
        current_user: null,
        current_users_cart_id: null,
        notes: "",
        terms: false,
        terms2: false,
        showCheckout: false,
        email: "",
        found_ecu: false,
        ecu_msg: "",
        show_remap_options: false,
        show_options: false,
        login: {
            email: "",
            password: "",
            error_msg: ""
        },
        signup: {
            email: "",
            password: "",
            error_msg: ""
        },
        // define what a vehicle object should look like
        // to perform the compatibility and options selection
        current_vehicle: {
            id: "",
            make: "",
            model: "",
            vin: "",
            reg: "",
            ecu_type: null,
            current_mods: "",
            bhp: "",
            transmission_type: "",
            transmission: "",
            engine_capacity: "",
            engine_code: "",
            gearbox_code: "",
            gearbox_model: null,
            year: "",
            drive_type: ""
        },
        //define what an 'issue' should look like for the incompatible returns
        issue: {
            type: "",
            message: {
                title: "",
                main: "",
                small: "",
            },
            query: "",
            customer_email: "",
        },
        ShowOnsite: true,
        // add context to what's allowed
        veh_make_options: ["Audi", "BMW", "Cupra", "Mini", "Man", "Porsche", "Seat", "Skoda", "Volkswagen"],
        canUseSearch: false,
    }),
    mounted() {
        // fucked if i know - shame this is the only comment to explain it
        if (this.$refs.select) {
            this.$refs.select.$refs.control.$refs['value-container'].$refs.input.$refs.input.setAttribute('isp_ignore', '');
        }
        // check if the user is logged in and if so get their
        // information so we can interact with their Cart
        this.GetCurrentUser();
        // See if they already have a Cart on BigCommerce or
        // whether we need to create a new one with their Tuning options
        this.GetCurrentUsersCart();
    },
    methods: {
        LoginCustomer(e) {
            const button = e.currentTarget;
            if (this.login.email !== "" && this.login.password !== "") {
                button.disabled = true;
                button.innerText = "Signing in...";

                // Skip actual login during development
                if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
                    console.log("Skipping real login for local development");
                    button.innerText = "SIGNED IN! (Local)";
                    button.disabled = false;

                    // Mock a successful login state
                    this.current_user = {
                        id: 9999,
                        email: "dev@localhost",
                    };
                    return;
                }

                axios.post(api_url + "/api/powergate/customer/login", {
                    email: this.login.email,
                    password: this.login.password,
                    // form: "powergate"
                    // pick the relevant form - as the user is redirected once the token is in session
                    form: "powergate3Legacy"
                }).then((resp) => {
                    console.log('Response: ', resp)
                    button.disabled = false;
                    button.innerText = "Sign in";
                    if (typeof resp.data == 'object') {
                        this.login.error_msg = resp.data;
                    } else {
                        button.innerText = "SIGNED IN!";
                        location.replace(`${this.baseURL}/login/token/` + resp.data)
                    }
                }).catch(err => {
                    console.error('Error: ', err);
                    button.disabled = false;
                    button.innerText = "Sign in";
                })
            }
        },
        GetServicesByVin() {
            if (this.current_user === null) {
                alert('NOT LOGGED IN');
                return false;
            }
            if (this.current_vehicle.vin.length === 17) {
                this.IsLoading = true;
                // call the API for services availability and prices
                axios.post(api_url + "/api/powergate/services", {
                    vin: this.current_vehicle.vin,
                    // PWG4  - uncomment the relevant one when building
                    // form: "powergate",
                    // PWG3
                    form: "powergate3Legacy",
                    customer_id: this.current_user.id
                }).then(resp => {
                    // if not vehicle then it's an Error message response, show the Alert
                    if (!('vehicle' in resp.data)) {
                        alert(resp.data);
                        this.IsLoading = false;
                    }
                    else if ('issue' in resp.data) {
                        this.$refs.issuedialog.issue.type = this.issue.type = resp.data.issue;
                        this.$refs.issuedialog.issue.title = this.issue.message.title = resp.data.messageTitle;
                        this.$refs.issuedialog.issue.message = this.issue.message.main = resp.data.messageBody;
                        this.$refs.issuedialog.issue.smallDisclaimer = this.issue.message.small = resp.data.messageSmall;

                        this.$refs.issuedialog.showIssueDialog = true;
                        this.current_vehicle = resp.data.vehicle;

                        if ('remap' in resp.data ) {
                            // this will be an MD1 response as it has a message and prices/services
                            this.remapOptions = resp.data.remap;
                            this.remapOptions.forEach(element => {
                                if (element.service.includes("Bespoke Tuning")) {
                                    element.service = "Bespoke Tuning"
                                }
                            });
    
                            this.withRemap = resp.data.withRemap;
                            this.options = resp.data.list;
                            this.tuningRate = resp.data.tuningRate;
    
                            let cp3 = this.options.filter(elm => elm.service.includes("CP3 Pump"));
                            if (cp3 && cp3.length > 0) {
                                cp3[0].service = "CP3 Pump Calibration Only"
                            }
                        }
                        this.IsLoading = false;
                    }
                    else {
                        this.current_vehicle = resp.data.vehicle;
                        this.remapOptions = resp.data.remap;

                        this.remapOptions.forEach(element => {
                            if (element.service.includes("Bespoke Tuning")) {
                                element.service = "Bespoke Tuning"
                            }
                        });

                        this.withRemap = resp.data.withRemap;
                        this.options = resp.data.list;
                        this.tuningRate = resp.data.tuningRate;

                        let cp3 = this.options.filter(elm => elm.service.includes("CP3 Pump"));
                        if (cp3 && cp3.length > 0) {
                            cp3[0].service = "CP3 Pump Calibration Only"
                        }
                        this.IsLoading = false;
                    }
                }).catch(err => {
                    alert("Something went wrong getting services! " + err);
                });
            }
            else {
                alert("Please enter a valid 17-digit VIN");
            }
        },
        GetServicesByReg() {
            // check if customer is logged in
            if (this.current_user === null) {
                alert('NOT LOGGED IN');
                return false;
            }
            if (this.current_vehicle.reg.length >= 3) {
                this.IsLoading = true;
                axios.post(api_url + "/api/powergate/services", {
                    reg: this.current_vehicle.reg,
                    // PWG4  - uncomment the relevant one when building
                    // form: "powergate",
                    // PWG3
                    form: "powergate3Legacy",
                    customer_id: this.current_user.id
                }).then(resp => {
                    // if not vehicle then it's an Error message response, show the Alert
                    if (!('vehicle' in resp.data)) {
                        alert(resp.data);
                        this.IsLoading = false;
                    }
                    else if ('issue' in resp.data) {
                        this.$refs.issuedialog.issue.type = this.issue.type = resp.data.issue;
                        this.$refs.issuedialog.issue.title = this.issue.message.title = resp.data.messageTitle;
                        this.$refs.issuedialog.issue.message = this.issue.message.main = resp.data.messageBody;
                        this.$refs.issuedialog.issue.smallDisclaimer = this.issue.message.small = resp.data.messageSmall;

                        this.$refs.issuedialog.showIssueDialog = true;
                        this.current_vehicle = resp.data.vehicle;

                        if ('remap' in resp.data ) {
                            // this will be an MD1 response as it has a message and prices/services
                            this.remapOptions = resp.data.remap;
                            this.remapOptions.forEach(element => {
                                if (element.service.includes("Bespoke Tuning")) {
                                    element.service = "Bespoke Tuning"
                                }
                            });
    
                            this.withRemap = resp.data.withRemap;
                            this.options = resp.data.list;
                            this.tuningRate = resp.data.tuningRate;
    
                            let cp3 = this.options.filter(elm => elm.service.includes("CP3 Pump"));
                            if (cp3 && cp3.length > 0) {
                                cp3[0].service = "CP3 Pump Calibration Only"
                            }
                        }
                        this.IsLoading = false;
                    }
                    else {
                        this.current_vehicle = resp.data.vehicle;
                        this.remapOptions = resp.data.remap;

                        this.remapOptions.forEach(element => {
                            if (element.service.includes("Bespoke Tuning")) {
                                element.service = "Bespoke Tuning"
                            }
                        });

                        this.withRemap = resp.data.withRemap;
                        this.options = resp.data.list;
                        this.tuningRate = resp.data.tuningRate;

                        let cp3 = this.options.filter(elm => elm.service.includes("CP3 Pump"));
                        if (cp3 && cp3.length > 0) {
                            cp3[0].service = "CP3 Pump Calibration Only"
                        }
                        this.IsLoading = false;
                    }
                }).catch(err => {
                    alert("Something went wrong getting services! " + err);
                });
            } 
            else {
                alert("Please enter a Valid UK Vehicle Registration")
            }
        },
        RedirectToVagPage() {
            // it may appear like it is not used but this method is used by the modal component button to
            // redirect customers to the VAG page if we can tune on-site but not with powergate
            window.location.href = `${this.baseURL}/ecu-tuning-vag-porsche/`;
        },
        SelectOption(opt) {
            if (opt.target) {
                if (opt.target.selectedIndex === 0) {
                    this.remapOptions.forEach((el) => {
                        el.checked = false;
                    });
                    this.withRemap.forEach((el) => {
                        el.checked = false;
                    });
                    this.selectedRemap = false;
                    this.options.forEach(element => {
                        element.hidden = false;
                    });
                    let cp3Pump = this.options.find(elm => elm.service.includes("CP3 Pump"));
                    if (cp3Pump) {
                        cp3Pump.hidden = false;
                        cp3Pump.service = "CP3 Pump Calibration Only";
                    }
                } else {
                    let cp3 = this.options.find(elm => elm.service.includes("CP3 Pump"));

                    this.remapOptions.forEach(el => {
                        el.checked = false;
                    });
                    this.remapOptions[opt.target.selectedIndex - 1].checked = true;
                    this.selectedRemap = true;

                    if (this.remapOptions[opt.target.selectedIndex - 1].service.includes('Pump')) {
                        console.log(cp3)
                        if (cp3) {
                            cp3.hidden = true;
                            cp3.checked = false;
                        }
                    } else {
                        if (cp3) {
                            cp3.hidden = false;
                        }
                    }

                    this.withRemap.forEach(element => {
                        let el = element.service.replace('with Remap', '');
                        let opts = this.options.filter(elm => elm.service === el.trim());
                        opts.forEach(op => {
                            op.hidden = true;
                            op.checked = false;
                        });
                    });

                    if (this.remapOptions[opt.target.selectedIndex - 1].service.startsWith('Remap') || this.remapOptions[opt.target.selectedIndex - 1].service.startsWith('Bespoke')) {
                        if (cp3) {
                            cp3.service = "CP3 Pump";
                        }
                    } else {
                        if (cp3) {
                            cp3.service = "CP3 Pump Calibration Only";
                        }
                    }
                }
            } else {
                // If this is an "Under Development" Option
                if (opt.price === 'UD') {
                    this.$refs.dsddialog.showDialog = true;
                    this.$refs.dsddialog.service = opt;
                    this.$refs.dsddialog.ecu = this.current_vehicle.ecu;
                    return;
                }

                // If this is a gearbox stage option
                if (opt.service.includes('Gearbox Stage')) {
                    // Uncheck all other gearbox stage options
                    const gearboxOptions = [...this.options, ...this.withRemap].filter(
                        item => item.service.includes('Gearbox Stage') && item !== opt
                    );

                    gearboxOptions.forEach(item => {
                        item.checked = false;
                    });
                }

                opt.checked = opt.checked === false;
            }
            this.$forceUpdate();
        },
        SelectRemapOption(opt, index) {
            if (opt === "No Remap") {
                // if the customer selects the 'No Remap' option then
                // make sure to un-check and check all currently selected
                this.remapOptions.forEach((el) => {
                    el.checked = false;
                });
                this.withRemap.forEach((el) => {
                    el.checked = false;
                });
                // set selectedRemap to false, so that the watcher picks up the changes
                // and shows/hides the relevant options for that remap choice
                this.selectedRemap = false;

                // The watcher should be doing this
                this.options.forEach(element => {
                    element.hidden = false;
                });

                // look through the options to see if there is one that has  service name CP3 Pump
                let cp3Pump = this.options.find(elm => elm.service.includes("CP3 Pump"));
                // if it's found, set it's hidden property to false so that it is shown on the frontend
                // and rename the service
                if (cp3Pump) {
                    cp3Pump.hidden = false;
                    cp3Pump.service = "CP3 Pump Calibration Only";
                }
            } else {
                // customer has chosen to have a remap

                // look to see if CP3 Pump is in the options that are available
                let cp3 = this.options.find(elm => elm.service.includes("CP3 Pump"));

                // make sure that none of the remapOptions have been pre-selected
                // by defaulting them all to false
                this.remapOptions.forEach(el => {
                    el.checked = false;
                });
                // set the remap option
                this.remapOptions[index].checked = true;
                // update the variable for the watcher to pick up and make the frontend changes to the options
                this.selectedRemap = true;
                // check if we have the CP3 pump in withRemap, passed back from the API
                if (this.remapOptions[index].service.includes('Pump')) {
                    // if we do, then hide the CP3 Pump option that is in the Options array
                    // if it exists
                    if (cp3) {
                        cp3.hidden = true;
                        cp3.checked = false;
                    }
                } else {
                    // else use the Options one instead which will have a larger price
                    if (cp3) {
                        cp3.hidden = false;
                    }
                }
                // foreach option in the withRemap array
                this.withRemap.forEach(element => {
                    // if the name contains 'with Remap', then remove this part of the name
                    const el = element.service.replace('with Remap', '');
                    // this is done to make visual changes to the non-remap service verion to hide them
                    // again, im certain this should be left to the watchers below
                    let opts = this.options.filter(elm => elm.service === el.trim());
                    opts.forEach(op => {
                        op.hidden = true;
                        op.checked = false;
                    });
                });

                // as the above CP3 logic but for bespoke tunes
                if (this.remapOptions[index].service.startsWith('Remap') || this.remapOptions[index].service.startsWith('Bespoke')) {
                    if (cp3) {
                        cp3.service = "CP3 Pump";
                    }
                } else {
                    if (cp3) {
                        cp3.service = "CP3 Pump Calibration Only";
                    }
                }
            }

            // as far as I know the new pricing schema no longer lists service prices as UD
            // - I will need to check that there isn't any logic somewhere else setting null
            // values to 'UD' for example before I completely remove this snippet
            if (this.remapOptions[index].price === 'UD') {
                this.$refs.dsddialog.showDialog = true;
                this.$refs.dsddialog.service = opt;
                this.$refs.dsddialog.ecu = this.current_vehicle.ecu;
                return;
            }
            this.$forceUpdate();
        },
        GetCurrentUser() {
            // get the current customers details like BC ID and email etc.
            // Also checks to see if the customer belongs in any special groups, like 'Trade'
            const self = this;
            const appClientId = "igimdk6jnrt5g5mbwui5gi7f7ke1w5p";
            const xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState === 4) {
                    if (xmlhttp.status === 200) {
                        let curr_user = jwt_decode(xmlhttp.responseText);
                        self.current_user = curr_user.customer;
                        self.email = self.current_user.email;
                        self.GetUserGroup(self.current_user);
                    }
                    else if (xmlhttp.status === 404) {
                        console.log("Not logged in!");
                    }
                    else {
                        console.error("Something went wrong");
                    }

                    if (self.$refs.select) {
                        self.$refs.select.$refs.control.$refs['value-container'].$refs.input.$refs.input.setAttribute('isp_ignore', '');
                    }
                }
            };
            xmlhttp.open("GET", `${this.baseURL}/customer/current.jwt?app_client_id=` + appClientId, true);
            xmlhttp.send();
        },
        GetCurrentUsersCart() {
            // ping the bigcommerce API to see if the customer already has an existing cart with items in.
            // this is important because they may be using a different currency to GBP
            // Meaning that when we create the cart item, the price is being set - but not converted
            // into the right currency leading to undercharging USA customers etc
            const self = this;
            fetch('/api/storefront/cart', {
                credentials: 'include'
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {
                if (myJson.length > 0) {
                    self.current_users_cart_id = myJson[0].id;
                }
            });
        },
        ShowCheckout() {
            this.showCheckout = true;
        },
        CreateOrder(e) {
            // validate we have all the data we need to create a
            // cart item which can be purchased through checkout
            if (this.SelServices.length === 0) {
                alert("At least 1 service is required.");
                return;
            }
            if (this.current_vehicle.vin === null) {
                alert("Please fill in all required fields.");
                return;
            }
            if (this.current_vehicle.ecu_type === null) {
                alert("Please fill in all required fields.");
                return;
            }

            if (this.current_vehicle.model === "") {
                alert("Please fill in all required fields.");
                return;
            }

            if (this.current_vehicle.make === "Choose Options") {
                alert("Please fill in all required fields.");
                return;
            }
            e.target.disabled = true;
            // check before sending to API to see if they have an existing cart
            // it does this onMount too, just in case.
            this.GetCurrentUsersCart();
            // send the data to our API which will talk to BC API to create a Cart
            // with the selected options and price, and then assign it to the customer
            const url = "https://tuning.darkside-developments.com/api/create/order";
            axios.post(url,
                {
                    user_id: this.current_user.id,
                    user_email: this.current_user.email,
                    price: this.optionsTotal,
                    vehicle_id: this.current_vehicle.id,
                    vin: this.current_vehicle.vin,
                    reg: this.current_vehicle.reg,
                    notes: this.notes,
                    ecu: this.current_vehicle.ecu,
                    make: this.current_vehicle.make,
                    model: this.current_vehicle.model,
                    services: JSON.stringify(this.SelServices),
                    cart_id: this.current_users_cart_id,
                    current_mods: this.current_vehicle.current_mods
                }
            ).then(resp => {
                if (resp.data.status === "Success") {
                    window.location.replace(resp.data.msg);
                } else {
                    alert(resp.data.msg)
                }
                e.target.disabled = false;
            })
                .catch(err => {
                    alert("Something went wrong!");
                    console.log(err);
                    e.target.disabled = false;
                });
        },
        GetPrice(val) {
            if (parseInt(val)) {
                return "£" + parseInt(val)
            }
            return val;
        },
        GoToSignin() {
            //redirect the customer to the sign-in page as they must be logged in to perform a search
            window.location.href = `${this.baseURL}/login.php`;
        },
    },
    computed: {
        SelServices() {
            // merge the customers selected options and remaps into a new array
            // this array will be passed into the API and also added as notes to
            // the order and also the notes in the tuning ticket
            const newArr = this.options.concat(this.remapOptions, this.withRemap);
            const arr = [];
            newArr.forEach(element => {
                if (element.checked) {
                    arr.push(element);
                }
            });
            return arr;
        },
        optionsTotal() {
            // calculate the total cart price based on the customers remap and options selections
            // eg: sum all 'checked' services.prices
            // this total will be passed to the API for when we create the cart item for the customer
            let total = 0;
            this.SelServices.forEach(el => {
                if (el.checked) {
                    if (parseInt(el.price)) {
                        total += parseInt(el.price);
                    }
                }
            });
            return total;
        },
        bespokeSelected() {
            // select the option with the service name of Bespoke Tuning so that it can be added to the cart
            const tune = this.SelServices.find(el => el.service === "Bespoke Tuning");
            return !!(tune && tune.checked === true);
        },
        canPurchaseTune() {
            // the user is logged in and there are no errors = true
            return this.current_user.id > 0 && this.issue.type === "";
        }
    },
    watch: {
        // this watcher is responsible for setting the hidden
        // context of an option depending on whether the customer has selected a remap or not
        options: {
            handler() {
                // check if the customer has selected a remap, then hide/show the following options that
                // are not in the RemapOptions for this vehicle
                if (this.selectedRemap) {

                    const hl = this.options.find(el => el.service === "Hardcut Limiter");
                    if (hl) {
                        hl.hidden = false;
                        hl.checked = false
                    }

                    const lc = this.options.find(el => el.service === "Launch Control");
                    if (lc) {
                        lc.hidden = false;
                        lc.checked = false
                    }

                    const egr = this.options.find(el => el.service === "EGR Software");
                    if (egr) {
                        egr.hidden = true;
                        egr.checked = false;
                    }

                    const dpfegr = this.options.find(el => el.service === "DPF and EGR Software");
                    if (dpfegr) {
                        dpfegr.hidden = true;
                        dpfegr.checked = false;
                    }

                    const lfb = this.options.find(el => el.service === "Left Foot Brake");
                    if (lfb) {
                        lfb.hidden = false;
                        lfb.checked = false
                    }

                    const ms = this.options.find(el => el.service === "Map Switching");
                    if (ms) {
                        ms.hidden = false;
                        ms.checked = false
                    }
                }

                // if no remap selected
                else {
                    // Hide these options
                    const hl = this.options.find(el => el.service === "Hardcut Limiter");
                    if (hl) {
                        hl.hidden = true;
                        hl.checked = false
                    }

                    const lc = this.options.find(el => el.service === "Launch Control");
                    if (lc) {
                        lc.hidden = true;
                        lc.checked = false
                    }

                    const lfb = this.options.find(el => el.service === "Left Foot Brake");
                    if (lfb) {
                        lfb.hidden = true;
                        lfb.checked = false
                    }

                    const ms = this.options.find(el => el.service === "Map Switching");
                    if (ms) {
                        ms.hidden = true;
                        ms.checked = false
                    }

                    // Show these options
                    const egr = this.options.find(el => el.service === "EGR Software");
                    if (egr) {
                        egr.hidden = false;
                        egr.checked = false;
                    }

                    const dpfegr = this.options.find(el => el.service === "DPF and EGR Software");
                    if (dpfegr) {
                        dpfegr.hidden = false;
                        // dpfegr.checked = false; Somehow fixes this option not being selectable? Only seems to affect this option?
                    }
                }
            },
            deep: true
        },
        // this watcher is responsible for setting the hidden
        // context of a RemapOption depending on whether the customer has selected a remap or not
        withRemap: {
            handler() {
                let hl, lc, lfb, ms, egr, dpfegr;
                // check if the customer has selected a remap, then hide/show the following RemapOptions that
                // are also in the Options array for this vehicle
                if (this.selectedRemap) {
                    console.log(this.selectedRemap)
                    hl = this.withRemap.find(el => el.service === "Hardcut Limiter");
                    if (hl) {
                        hl.hidden = false;
                        hl.checked = false;
                    }

                    egr = this.withRemap.find(el => el.service === "EGR Software");
                    if (egr) {
                        egr.hidden = false;
                        egr.checked = false;
                    }

                    dpfegr = this.withRemap.find(el => el.service === "DPF and EGR Software");
                    if (dpfegr) {
                        dpfegr.hidden = false;
                        dpfegr.checked = false;
                    }

                    lc = this.withRemap.find(el => el.service === "Launch Control");
                    if (lc) {
                        lc.hidden = false;
                        lc.checked = false;
                    }

                    lfb = this.withRemap.find(el => el.service === "Left Foot Brake");
                    if (lfb) {
                        lfb.hidden = false;
                        lfb.checked = false;
                    }

                    ms = this.withRemap.find(el => el.service === "Map Switching");
                    if (ms) {
                        ms.hidden = false;
                        ms.checked = false;
                    }
                } else {

                    hl = this.withRemap.find(el => el.service === "Hardcut Limiter");
                    if (hl) {
                        hl.hidden = true;
                        hl.checked = false;
                    }

                    egr = this.withRemap.find(el => el.service === "EGR Software");
                    if (egr) {
                        egr.hidden = true;
                        egr.checked = false;
                    }

                    dpfegr = this.withRemap.find(el => el.service === "DPF and EGR Software");
                    if (dpfegr) {
                        dpfegr.hidden = true;
                        dpfegr.checked = false;
                    }

                    lc = this.withRemap.find(el => el.service === "Launch Control");
                    if (lc) {
                        lc.hidden = true;
                        lc.checked = false
                    }

                    lfb = this.withRemap.find(el => el.service === "Left Foot Brake");
                    if (lfb) {
                        lfb.hidden = true;
                        lfb.checked = false
                    }

                    ms = this.withRemap.find(el => el.service === "Map Switching");
                    if (ms) {
                        ms.hidden = true;
                        ms.checked = false
                    }
                }
            },
            deep: true
        },
        'current_vehicle.make'(val) {
            // Convert the selected/found vehicle 'Make' to uppercase
            const valU = val.toUpperCase();
            // Convert the makes in the array to uppercase then check
            const makesU = this.veh_make_options.map(make => make.toUpperCase());
            // is the selected/found vehicle 'Make' in the allowed array
            if (makesU.includes(valU)) {
                this.canUseSearch = true;
            } else {
                alert("We do not offer tuning for your Vehicle!");
            }
        },
        'current_vehicle.bhp'(val) {
            // divides by 1 and looks for a
            // remainder to confirm if it's a float
            if (val % 1 !== 0) {
                this.current_vehicle.bhp = Math.round(val)
            }
        }
    }
};
</script>

<style scoped>
.container.mt-5 {
    margin: 0 auto;
    max-width: 800px;
    width: 100%;
}

#modal-login-overlay,
#modal-login-modal {
    /*display: none;*/
    position: fixed;
}

#modal-login-modal span {
    cursor: pointer;
    display: block;
    float: right;
    font-size: 30px;
}

#modal-login-overlay {
    background-color: rgba(0, 0, 0, 0.8);
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 998;
}

#modal-login-modal {
    position: fixed;
    left: 50%;
    max-width: 300px;
    top: 20%;
    transform: translateX(-50%);
    width: 100%;
    z-index: 999;
}


.login-screen {
    background-color: #FFF;
    padding: 20px;
    border-radius: 5px
}

.login-modal-title {
    text-align: center;
    color: #777;
}

.login-modal-title h1 {
    margin-top: 20px;
    margin-bottom: 20px;
}

.login-modal-form {
    text-align: center;
}

.modal-control-group {
    margin-bottom: 10px;
}

input.login-modal-field {
    text-align: center;
    background-color: #ECF0F1;
    border: 2px solid transparent;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 200;
    padding: 10px 0;
    width: 250px;
    transition: border .5s;
}

input.login-modal-field:focus {
    border: 2px solid #3498DB;
    box-shadow: none;
}

.btn.login-modal-btn {
    border: 2px solid transparent;
    background: #ef060a;
    color: #ffffff;
    font-size: 16px;
    line-height: 25px;
    padding: 10px 0;
    text-decoration: none;
    text-shadow: none;
    text-transform: uppercase;
    border-radius: 3px;
    box-shadow: none;
    transition: 0.25s;
    display: block;
    width: 250px;
    margin: 0 auto;
}

.btn.login-modal-btn:hover {
    background-color: #be0508;
}

.login-modal-link {
    font-size: 12px;
    color: #444;
    display: block;
    margin-top: 12px;
}

.form-field {
    text-align: left;
    margin: 0 !important;
}

.d-flex-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}

.d-flex-container .form-field {
    width: 49% !important;
}

.d-block {
    display: block !important;
    width: 100% !important
}

ul {
    list-style: none
}

ul.options li {
    padding: 10px;
    border: 1px solid #dcdcdc;
    margin-bottom: 10px;
    display: flex;
    cursor: pointer;
    font-weight: bold;
    transition: all 0.2s;
    text-align: left !important;
}

ul.options.remap li {
    display: block;
}

ul.options li:hover {
    box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.03),
        0 -2px 4px 3px rgba(0, 0, 0, 0.03);
    background: #eee;
    /*rgba(239, 6, 10, 0.4)*/
}

ul.options li.selected {
    background: #ef060a;
    color: #fff;
}

ul.options li span {
    font-weight: bold;
    margin-left: auto
}

label {
    display: block;
    font-weight: bold;
}

.no-padding {
    padding: 0
}

.no-margin {
    margin: 0;
}

.mt-sm {
    margin-top: 10px;
}

.mb-sm {
    margin-bottom: 10px;
}

.mt-md {
    margin-top: 20px;
}

.mb-md {
    margin-bottom: 20px;
}

#modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    z-index: 99;
}

.checkout-modal {
    position: fixed;
    top: 20px;
    z-index: 999;
    width: auto !important;
}

#container-top span {
    color: #fff;
    text-transform: uppercase;
}

#container,
#container-top,
#container-upsell {
    max-width: 480px;
    height: auto;
    margin: auto;
    font-family: "Oswald", sans-serif;
    text-align: center;
}

#container {
    background: #fff;
    padding: 25px 40px 40px 40px;
    border-radius: 0 0 3px 3px;
}

#container-top {
    background: #444;
    padding: 3px 40px;
    border-radius: 3px 3px 0 0;
}

#container-top p {
    color: #ccc;
    font-size: 14px;
}

#container-top a {
    color: #3ca773;
    text-decoration: none;
}

#secure-tag {
    background: #444;
    text-transform: uppercase;
    font-family: Oswald;
    font-size: 9px;
    color: #ffffff;
    letter-spacing: 1px;
    line-height: 11px;
    padding: 7px 8px;
    margin: 20px auto;
    max-width: 123px;
    border-radius: 3px;
    text-align: center;
}

#container fieldset {
    border: 0;
    margin: 0;
    padding: 0;
}

#container input {
    width: 100%;
    background: #eeeeee;
    box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border: 0;
    margin-bottom: 15px;
    font-family: Oswald;
    font-size: 14px;
    color: #888888;
    letter-spacing: 0.2px;
    line-height: 17px;
    padding: 14px 17px;
}

#container input.half-form {
    width: 48.2%;
    margin-right: 10px;
}

#container .last {
    margin-right: 0 !important;
}

#container :focus {
    outline: 0;
}

#container text:focus,
#container input:focus {
    border: 2px solid #3ca773;
    padding: 12px 15px;
    box-shadow: none;
}

/*#container input:valid {
	background-image: url("http://www.clipartbest.com/cliparts/dT7/ojn/dT7ojn8T9.png");
	background-size: 20px;
	background-repeat: no-repeat;
	background-position: 96% 50%;
	color: #444;
	border: 0;
	padding: 14px 17px;
}*/

#container .btn {
    background: #3ca773;
    background-image: none !important;
    border-radius: 4px;
    box-shadow: none;
    font-family: Montserrat-Bold;
    font-size: 11px;
    color: #ffffff !important;
    letter-spacing: 2px;
    line-height: 13px;
    padding: 17px 17px !important;
    border: none;
    margin-bottom: 0;
    text-transform: uppercase;
}

#container a.btn {
    display: block;
    text-decoration: none;
    width: 400px;
}

#container .btn:hover {
    background: #38835f;
}

.input-ecu label {
    display: block;
}

.contain.d-flex {
    justify-content: center;
}

.contain.d-flex>div {
    width: 100%;
}

.contain.d-flex .content {
    width: 100%;
}

.list-style-none {
    list-style: none;
    padding: 0;
    margin: 0;
}

.contain {
    margin: 0 auto;
    max-width: 800px;
    width: 100%;
}

.ml-auto {
    margin-left: auto;
}

.mr-auto {
    margin-right: auto;
}

.d-flex {
    display: flex;
    align-items: center;
}

.icon-btn {
    text-transform: none;
    white-space: nowrap;
    -webkit-box-align: center;
    align-items: center;
    border-radius: 20em;
    text-align: center;
    line-height: 24px;
    font-weight: 500;
    display: flex;
    z-index: 425;
    height: 30px;
    width: 30px;
    align-content: center;
    text-decoration: none;
    background: transparent;
    letter-spacing: normal;
    -webkit-box-pack: center;
    justify-content: center;
}

.service-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.service-input,
.service-list-item {
    transition: 0.25s all ease;
    padding: 0.5em 1.34em;
    border-radius: 6px;
    margin: 10px 0;
    height: 2em;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
}

.service-input::placeholder {
    font-family: "Montserrat", sans-serif;
}

.service-list-item {
    padding: 0.2em 1em;
    background: white;
    height: 100%;
    max-height: 40px;
}

.service-list-item:hover {
    box-shadow: 0 2px 20px 5px rgba(0, 0, 0, 0.05),
        0 -2px 20px 5px rgba(0, 0, 0, 0.05);
}

.service-list-item.service-list-checked {
    background: rgb(94, 94, 94);
}

.service-list-item.service-list-checked h5 {
    color: #fff;
}

.service-list-item.service-list-checked:hover {
    /*border: 1px solid rgba(231, 49, 94, 0.15);*/
    background: rgba(94, 94, 94, 0.8);
}

.service-list-checkbox {
    position: relative;
}

.service-list-item.service-list-checked .service-list-action .icon-btn {
    background: white;
}

.service-list-item.service-list-checked .service-list-checkbox {
    background: rgba(0, 0, 0, 0.2) !important;
    color: white;
}

.service-list-item.service-list-checked .icon-btn:hover,
.service-list-item.service-list-checked .service-list-checkbox:hover {
    background: rgba(0, 0, 0, 0.4);
    color: white;
}

.service-list-content {
    align-self: center;
}

.service-list-item:hover {
    cursor: pointer;
}

.service-list-item.service-list-checked .service-list-content,
.service-list-item.service-list-checked .service-list-title input {
    color: white;
}

.service-list-title {
    padding-right: 10px;
    font-size: 16px;
}

.service-list-action {
    font-size: 12px;
}

.service-list-title input {
    font-family: "Montserrat", sans-serif;
    background: transparent;
    font-size: 20px;
    padding: 2px 0;
    border: none;
    width: 100%;
}

.service-list-title input.service-list-edit {
    border-bottom: 2px solid #f36;
}

.service-list-item.service-list-checked .service-list-title input.service-list-edit {
    border-bottom: 2px solid #ff85a3;
}

.service-list-disabled {
    color: #ff85a3;
}

h5 {
    margin: 0;
}

@media (min-width: 801px) {
    .productView-options--3col .emthemesModez-productView-optionsGrid .form-field {
        width: calc(50% - 1.5rem);
    }
}

@media (min-width: 551px) {
    .productView-options--3col .emthemesModez-productView-optionsGrid .form-field {
        width: calc(33.33334% - 1.5rem);
    }
}

.productView-options--2col .emthemesModez-productView-optionsGrid .form-field,
.productView-options--3col .emthemesModez-productView-optionsGrid .form-field {
    width: calc(50% - 1.5rem);
    margin: 0 0.75rem 0.76923rem;
    border: 1px solid #dcdcdc;
    padding: 1rem;
    display: inline-block;
    vertical-align: top;
}

.form-field {
    width: 100%;
    margin: 0 0.75rem 0.76923rem;
    border: 1px solid #dcdcdc;
    padding: 1rem;
    display: inline-block;
    vertical-align: top;
}

/* Variables
================================== */
/* Tables
================================== */
.Rtable {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
}

.Rtable-cell {
    box-sizing: border-box;
    flex-grow: 1;
    width: 100%;
    padding: 0.8em 1.2em;
    overflow: hidden;
    list-style: none;
    border: solid 3px white;
    background: rgba(112, 128, 144, 0.2);
}

.Rtable-cell>h1,
.Rtable-cell>h2,
.Rtable-cell>h3,
.Rtable-cell>h4,
.Rtable-cell>h5,
.Rtable-cell>h6 {
    margin: 0;
}

/* Table column sizing
================================== */
.Rtable--1cols>.Rtable-cell {
    width: 100%;
}

.Rtable--2cols>.Rtable-cell {
    width: 50%;
}

.Rtable--3cols>.Rtable-cell {
    width: 33.33%;
}

.Rtable--4cols>.Rtable-cell {
    width: 25%;
}

.Rtable--5cols>.Rtable-cell {
    width: 20%;
}

.Rtable--6cols>.Rtable-cell {
    width: 16.6%;
}

/* Apply styles
================================== */
.Rtable {
    position: relative;
    top: 0px;
    left: 0px;
}

.Rtable-cell {
    margin: -3px 0 0 -0px;
    background-color: #ffffff;
    border-color: #ffffff;
}

/* Cell styles
================================== */
.Rtable-cell--dark {
    background-color: #000;
    border-color: #ffffff;
    color: #ffffff;
}

.Rtable-cell--dark>h1,
.Rtable-cell--dark>h2,
.Rtable-cell--dark>h3,
.Rtable-cell--dark>h4,
.Rtable-cell--dark>h5,
.Rtable-cell--dark>h6 {
    color: #ffffff;
}

.Rtable-cell--medium {
    background-color: #ffffff;
    border-color: #ffffff;
}

.Rtable-cell--light {
    background-color: #ffffff;
    border-color: #ffffff;
}

.Rtable-cell--highlight {
    background-color: #ffffff;
    border-color: #ffffff;
}

.Rtable-cell--alert {
    background-color: #ffffff;
    border-color: #ffffff;
    color: #ffffff;
}

.Rtable-cell--alert>h1,
.Rtable-cell--alert>h2,
.Rtable-cell--alert>h3,
.Rtable-cell--alert>h4,
.Rtable-cell--alert>h5,
.Rtable-cell--alert>h6 {
    color: #ffffff;
}

.Rtable-cell--head {
    background-color: #474747;
    color: #000;
}

.Rtable-cell--head2 {
    background-color: #5e5e5e;
    color: #000;
}

.Rtable-cell--head>h1,
.Rtable-cell--head>h2,
.Rtable-cell--head>h3,
.Rtable-cell--head>h4,
.Rtable-cell--head2>h4,
.Rtable-cell--head>h5,
.Rtable-cell--head>h6 {
    color: #ffffff;
}

.Rtable-cell--foot {
    background-color: #eaeaea;
    color: #000;
}

.Rtable-cell--foot2 {
    background-color: #c1c1c1;
    color: #000;
}

.dsd-box {
    width: 100%;
    border: 1px solid #dcdcdc;
    padding: 1rem;
    display: inline-block;
    vertical-align: top;
}

.Rtable-cell.dsd-box {
    display: block !important;
    background: transparent !important;
    color: #333 !important;
}

.Rtable-cell.dsd-box h4 {
    color: #333;
    font-weight: bold;
}

.info-btn {
    width: 100%;
    color: white;
    font-weight: bold;
    margin-top: 10px;
}

.options li small {
    font-size: 13px;
    display: flex;
    align-items: center;
    font-weight: normal;
}

.options.remap li small {
    font-size: 13px;
    display: flex;
    align-items: center;
    margin-left: 0px;
}

.dsd-banner-grey {
    display: block;
    padding: 10px;
    background: #8A8C8F;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    color: #000;
}

.productView-options--2col .emthemesModez-productView-optionsGrid,
.productView-options--3col .emthemesModez-productView-optionsGrid {
    margin: 0
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.login-modal-btn:disabled {
    background: rgb(94, 94, 94);
    cursor: pointer;
    user-select: none;
    pointer-events: none;
    opacity: 0.4
}

ul.options li span.powergate-price {
    width: 50px;
    display: block;
    margin-left: auto;
    text-align: right;
}

.static_page_images .column2 {
    float: left;
    width: 50%;
    padding: 5px;
}

.button.button--primary a {
    color: #fff;
}

.v-select {
    width: 100%;
}

.d-flex {
    display: flex;
}

.dsd-input {
    width: 100%;
}

.bsrow {
    font-weight: 400;
    font-size: 11px;
    justify-content: center;
}
</style>
